import React from 'react';
import ReactDOM from 'react-dom/client';

import Prp, { PrpProps } from './Prp';

const id = 'product-results-page';
const element = document.getElementById(id);

if (element) {
    const root = ReactDOM.createRoot(element);
    root.render(
        <React.StrictMode>
            <Prp />
        </React.StrictMode>,
    );
}
